import React, { useState } from "react";
import { useEffect } from "react";
import http from "../../../http";
import MaterialTable from "material-table";
import "../../../imageUrl";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  OutlinedInput,
  Select,
} from "@mui/material";
import AuthUser from "../../../Components/AuthUser";
import { toast } from "react-toastify";
import { userRoleLang } from "../../../Components/language/pages/userRoleLang";
import useLanguage from "../../../Components/language/useLanguage";

function UserRole() {
  const [userdata, setuserdata] = useState([]);
  const lan = useLanguage(userRoleLang);
  const { user } = AuthUser();
  const [role, setrole] = useState("");
  const [userEmail, setuserEmail] = useState("");
  const [stateUpdate, setstateUpdate] = useState();
  useEffect(() => {
    http.get(`/user-list`).then((res) => {
      if (res.status === 200) {
        setuserdata(res.data);
      }
    });
  }, [stateUpdate]);

  const columns = [
    {
      title: lan?.sl,
      field: "",
      render: (row) => <div>{row.tableData.id + 1}</div>,
      width: "20 !important",
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: lan?.userName,
      field: `name`,
    },
    {
      title: lan?.phone,
      field: `mobile`,
    },
    {
      title: lan?.email,
      field: `email`,
    },

    {
      title: lan?.assignedRole,
      field: `user_type`,
      render: (row) =>
        <div>
          {row.user_type === 'empty' ? '' : row.user_type === 'admin' ? lan?.admin : row?.user_type === 'cashier' ? lan?.cashier : row?.user_type === 'manager' ? lan?.manager : row?.user_type === 'sales' ? lan?.sales : row?.user_type}
        </div>,
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: lan?.action,
      field: `photo`,
      cellStyle: {
        textAlign: "center",
      },
      render: (row) => (
        <>
          <button
            onClick={(e) => {
              setOpen(true);
              setrole(row.user_type);
              setuserEmail(row.email);
            }}
            className="btn btn-sm action-btn"
          >
            {" "}
            <i class="fas fa-chevron-circle-right"></i>{" "}
          </button>
        </>
      ),
    },
  ];
  const [open, setOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  const updateUserRole = () => {
    const data = {
      authEmail: user.email,
      userEmail: userEmail,
      userType: role,
    };

    http
      .post(`/user-role-assign`, data)
      .then((res) => {
        if (res.status === 200) {
          setstateUpdate(Math.random());
          setOpen(false);
          toast.success("User role update sucessfully");
        }
      })
      .catch((err) => {
        console.log("err", err);
        setOpen(false);
        toast.error("Opps! Someting is wrong");
      });
  };
  return (
    <>
      <div className="page-content">
        <div className="custom-card patients-head ">
          <h5 className="fw-normal custom_py-3 px-2  text-start mb-2 card-title">
            {lan?.pageTitle}
            {/* <Link className="btn btn-sm btn-primary float-end" to="/add-banner">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-plus mb-1"
              >
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Add Banner
            </Link> */}
          </h5>
        </div>
        <div className="row">
          <div className="col-md-12 grid-margin">
            <div>
              <div>
                <MaterialTable
                  columns={columns}
                  data={userdata}
                  options={{
                    search: true,
                    showTitle: false,
                    searchFieldAlignment: "left",
                    pageSize: 10,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-2">
        <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
          <DialogTitle sx={{ fontSize: "15px" }}>{lan?.userRole}</DialogTitle>
          <DialogContent sx={{ padding: 0 }}>
            <FormControl sx={{ m: 1, minWidth: 150, padding: 0 }}>
              <InputLabel htmlFor="demo-dialog-native">{lan?.role}</InputLabel>
              <Select
                native
                value={role}
                onChange={(event) => {
                  setrole(event.target.value);
                }}
                sx={{ height: 40 }}
                input={<OutlinedInput label="Role" id="demo-dialog-native" />}
              >
                <option aria-label="None" value="" />
                <option value={"admin"}>{lan?.admin}</option>
                <option value={"manager"}>{lan?.manager}</option>
                <option value={"sales"}>{lan?.sales}</option>
                <option value={"supplier"}>{lan?.supplier}</option>
                <option value={"cashier"}>{lan?.cashier}</option>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>{lan?.cancel}</Button>
            <Button onClick={updateUserRole}>{lan?.assign}</Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}

export default UserRole;
